import React, { useContext } from "react";
import { Form } from "antd";
import { FormContext } from "./FormContext";

const { Item: AntdItem } = Form;

export const Item = React.forwardRef((props, ref) => {
  const ldForm = useContext(FormContext);
  const {
    name,
    label: labelProps,
    children: childrenProps,
    hasFeedback,
    rules: rulesProps,
    className: classNameProps,
    readOnly,
  } = props;
  const { children, label, rules, form, className, ...itemPropsTmp } = Object.assign({}, props);
  let validator = null;
  let isRequired = false;

  const childrenWithProps = React.Children.map(childrenProps, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        marker: { isRequired },
        ...(child.props.placeholder === undefined && labelProps !== undefined && { placeholder: labelProps }),
        value: ldForm.getFieldValue(name),
        ...(readOnly && readOnly !== undefined && { disabled: true }),
      });
    } else return child;
  })[0];

  let rulesCopy = [];
  if (rulesProps && rulesProps !== undefined && rulesProps.length > 0) {
    rulesCopy = rulesProps.map((rule) => {
      let rulesTmp = {};
      for (const [key, value] of Object.entries(rule)) {
        rulesTmp[key] = value;
      }
      if (rulesTmp["validator"] === undefined && validator) {
        delete rulesTmp.message;
        rulesTmp["validator"] = validator;
      }
      return rulesTmp;
    });
  }

  const itemProps = {
    ...itemPropsTmp,
    ...(hasFeedback !== undefined && { hasFeedback }),
  };

  const itemClassName = readOnly && readOnly !== undefined ? classNameProps + " readOnlyItem" : classNameProps;

  return (
    <AntdItem {...itemProps} className={itemClassName} rules={rulesCopy}>
      {childrenWithProps}
    </AntdItem>
  );
});
